import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import mailcheck from 'mailcheck';
import TextField from './TextField';
import withController from './lib/withController';

const EmailField = React.forwardRef(({
  value,
  onChange,
  helperText: originalHelperText,
  formatSuggestion,
  useStringOnClick,
  ...properties
}, reference) => {
  const { full: suggestedEmail } = { ...mailcheck.run({ email: value }) };
  const onClick = useCallback(
    () => {
      if (useStringOnClick) {
        onChange(suggestedEmail);
        return;
      }
      onChange({ target: { value: suggestedEmail } });
    },
    [onChange, suggestedEmail, useStringOnClick],
  );

  const emailSuggestion = (suggestedEmail && suggestedEmail !== value) && (
    <span
      onClick={onClick}
      onKeyDown={onClick}
      role="button"
      tabIndex={-1}
    >
      {formatSuggestion(suggestedEmail)}
    </span>
  );
  const helperText = emailSuggestion || originalHelperText;

  return (
    <TextField
      {...properties}
      type="text"
      onChange={onChange}
      value={value}
      helperText={helperText}
      ref={reference}
    />
  );
});

EmailField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  helperText: PropTypes.node,
  formatSuggestion: PropTypes.func,
  useStringOnClick: PropTypes.bool,
};

EmailField.defaultProps = {
  value: '',
  onChange: undefined,
  helperText: undefined,
  formatSuggestion: (email) => `Did you mean ${email}?`,
  useStringOnClick: false,
};

export const EmailFieldWithController = withController(EmailField);

export default EmailField;
